import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProfileCardModalComponent } from '../../modals/profile-card-modal/profile-card-modal.component';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit {
  isMenuOpen: boolean = false;

  constructor(private readonly dialogService: MatDialog) {}

  ngOnInit(): void {}

  openProfileCard() {
    this.dialogService.open(ProfileCardModalComponent, {
      panelClass: ['dialog-overlay-pane', 'landing-dialog-pane'],
      width: '800px'
    });
  }

  openMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  clickedOutside() {
    this.isMenuOpen = false;
  }
}
